import {useState} from 'react';
import {useDebounce} from '@netx/core-components/hooks/useDebounce';
import {isAutoListQueryValid} from '../../utils/autoList';

export type UseDebouncedQueryStringParams = {
	isQueryValid?: (query?: string) => boolean;
};

export const useDebouncedQueryString = ({
	isQueryValid = isAutoListQueryValid,
}: UseDebouncedQueryStringParams = {}) => {
	const [queryStr, setQueryStr] = useState<string>();
	const [debouncedQueryStr] = useDebounce(queryStr, 50);

	const queryIsValid = isQueryValid(queryStr);

	return {
		debouncedQueryStr,
		queryIsValid,
		queryStr,
		setQueryStr,
	};
};
